import { useEffect, useRef } from "react";

const useCheckoutReturnRecovery = (checkoutInFlightRef, onRecover) => {
  const recoveryInProgressRef = useRef(false);

  useEffect(() => {
    const handlePageShow = () => {
      if (
        !checkoutInFlightRef.current ||
        recoveryInProgressRef.current
      ) {
        return;
      }

      recoveryInProgressRef.current = true;
      Promise.resolve()
        .then(() => onRecover())
        .catch(() => null)
        .finally(() => {
          checkoutInFlightRef.current = false;
          recoveryInProgressRef.current = false;
        });
    };

    window.addEventListener("pageshow", handlePageShow);
    return () => window.removeEventListener("pageshow", handlePageShow);
  }, [checkoutInFlightRef, onRecover]);
};

export default useCheckoutReturnRecovery;
